import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CallingScriptModal = ({
  showCallingScript,
  handleClose,
  customer_name,
  product_name,
  customer_mobile_number,
  notice_date,
  email_id,
  loan_account_no,
  pos,
  pre_approved_settlement_amount,
  collection_manager_name,
  collection_manager_mobile_number,
  client_name,
  client_id,
  vehicle_type,
  vehicle_number,
}) => {
  const [language, setLanguage] = useState(client_id === 10 ? 'hindi' : 'english');

  // Helper to format date like "4th December 2025"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const hasSettlementAmount = Number(pre_approved_settlement_amount) > 0;

  return (
    <Modal show={showCallingScript} onHide={handleClose} centered dialogClassName="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notice Information</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {client_id === 10 ? (
          // Client 10 Script (Werize / TVS Credit)
          language === 'hindi' ? (
            <div>
              <p className='mt-3'>
                Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
              </p>
              <p>
                Ye call aapke TVS Credit ke loan account se related hai, jo <strong>{vehicle_type}</strong> – Vehicle No. <strong>{vehicle_number}</strong> par liya gaya tha.
              </p>
              <p>
                Payment default ke chalte aapka vehicle repossess aur sell kiya ja chuka hai. Sale ke baad bhi poora loan recover nahi ho paaya.
              </p>
              <p>
                Is case mein <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID / address par legal notice bheja ja chuka hai.
              </p>
              <p>
                Sale adjustment ke baad, aap par <strong>₹{pos}</strong> abhi bhi legally payable hai, aur isi recovery ke liye TVS Credit ne ye case hume legal action ke liye assign kiya hai.
              </p>
              <p>
                Lekin legal action se pehle, aapko ek final opportunity di ja rahi hai jisme <strong>₹{pre_approved_settlement_amount || 0}</strong> ke waiver amount par is matter ko close kiya ja sakta hai.
                Isse aapka CIBIL record improve hoga aur aage chal kar loan eligibility bhi restore ho sakti hai, subject to timely payment.
              </p>
              <p>
                Agar aap waiver ke liye agree karte hain, to isi call par confirm karein.
                Agar aap cooperate nahi karte, to legal action as per law without any further notice initiate kiya jayega.
              </p>
            </div>
          ) : (
            <div>
              <p className='mt-3'>
                Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
              </p>
              <p>
                This call is in relation to your TVS Credit loan account for <strong>{vehicle_type}</strong> – Vehicle No. <strong>{vehicle_number}</strong>.
              </p>
              <p>
                Due to continuous payment default, the vehicle was repossessed and sold as per due process. However, even after adjusting the sale proceeds, the entire loan outstanding could not be recovered.
              </p>
              <p>
                A legal notice was already issued on <strong>{formatDate(notice_date)}</strong> to your registered email ID / address.
              </p>
              <p>
                After adjustment of sale proceeds, a balance amount of <strong>₹{pos}</strong> remains legally payable. For recovery of this balance, TVS Credit has assigned this case to us for initiating legal action.
              </p>
              <p>
                However, before proceeding legally, you are being given a final opportunity to resolve the matter through a waiver option, wherein the account can be closed against a payment of <strong>₹{pre_approved_settlement_amount || 0}</strong>, subject to immediate confirmation and timely payment.
              </p>
              <p>
                Closure under this waiver will also help improve your CIBIL record and may enable you to avail loans in the future, subject to credit policies.
              </p>
              <p>
                If you are agreeable to this waiver, please confirm during this call.
                If not, we will proceed with legal action as per law, without any further notice.
              </p>
            </div>
          )
        ) : (
          // Default Script (Client 83 / others)
          language === 'english' ? (
            <div>
              <p className='mt-3'>
                Hi, I am calling from K S Legal. Am I speaking with <strong>{customer_name}</strong>?
              </p>

              <p>
                You have defaulted on the <strong>Credit Card</strong> account ending <strong>{loan_account_no}</strong>, issued by <strong>{client_name}</strong>. Is that correct?
              </p>

              <p>
                We have been assigned this case by <strong>{client_name}</strong> to initiate legal proceedings. A legal notice has already been sent to your registered email ID on <strong>{formatDate(notice_date)}</strong>.
              </p>

              <p>
                Due to continuous non-payment, the Bank has instructed us to proceed with legal action, which may include civil proceedings, criminal proceedings, or a police complaint, as per law.
              </p>

              <p>
                However, before proceeding legally, the Bank is offering you a One Time Settlement. Your total outstanding is <strong>₹{pos}</strong>
                {hasSettlementAmount ? (
                  <span>, which can be settled for <strong>₹{pre_approved_settlement_amount}</strong></span>
                ) : (
                  <span></span>
                )}, subject to immediate confirmation aur payment.
              </p>

              <p>
                If you are agreeable to this One Time Settlement, please confirm during this call. If not, we will proceed with legal action as instructed by the Bank.
              </p>
            </div>
          ) : (
            <div>
              <p className='mt-3'>
                Hi, main K S Legal se bol raha hoon. Kya main <strong>{customer_name}</strong> se baat kar raha hoon?
              </p>

              <p>
                Aapka <strong>{client_name}</strong> ka <strong>Credit Card</strong> account <strong>{loan_account_no}</strong> pe end hota hai aur system ke according aapka payment default mein hai — kya ye sahi hai?
              </p>

              <p>
                Ye case hume legal proceedings start karne ke liye assign kiya gaya hai. <strong>{formatDate(notice_date)}</strong> ko aapke registered email ID par legal notice bheja ja chuka hai.
              </p>

              <p>
                Legal action se pehle, Bank aapko One Time Settlement ka final option de raha hai. Aapka total outstanding <strong>₹{pos}</strong> hai
                {hasSettlementAmount ? (
                  <span>, jo <strong>₹{pre_approved_settlement_amount}</strong> mein settle ho sakta hai</span>
                ) : (
                  <span></span>
                )}, subject to immediate confirmation aur payment.
              </p>

              <p>
                Agar aap agree karte hain, isi call par confirm karein. Agar nahi, to Bank ke instructions ke according legal action proceed kiya jayega.
              </p>
            </div>
          )
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between w-100">
        <Button
          variant="primary"
          size="md"
          onClick={() => setLanguage(language === 'english' ? 'hindi' : 'english')}
        >
          {language === 'english' ? 'Switch to Hindi' : 'Switch to English'}
        </Button>

        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default CallingScriptModal;